import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { generateAddedValueFormName } from '../../../../helpers/form-added-value-name-generator';
import { AddedValueFieldConfig } from '../../../../models/form-added-value-field-config';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import {
  LocalSpacingsLoaderService,
  SingleApplicationsLoaderService,
  SingleUnloadTimesLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
// product form field
import { ProductsOptionsLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/products.loader.service';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import {
  LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-added-value-not-formulating.command.service';
import { FormInputDateComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { FormInputTimeComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { TimepickerHourFormat } from '@ordersnproducts/modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { FieldInputTimeConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import { LoadSingleCatalogsUnloadType } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsApplication } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { LoadSingleCatalogsSpacing } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadSingleCatalogsUnloadTime } from '../../../../services/config-loader/commands/single-catalogs-unload-time.command.service';
import { LoadContractOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/load-contract.command.service';
import { RmsChildrenStrategies } from '../../../../models/rms-children-strategies';
import { ContractsOptionLoaderOpenPlatformService } from '../../../../services/config-loader/loaders/open-platform/contract.loader.service';
import { ProductsOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/products-options.provider';
import { ContractOptionsLoaderOpenPlatformProvider } from '../../../../providers/open-platform/contracts.provider';
import { MasterDateBlocker } from '../../../../providers/open-platform/date-blocker.provider';
import { LoadSingleCatalogsProjectProfile } from '../../../../services/config-loader/commands/single-catalogs-project-profile.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { SetTimepickerDateFromDatepickerCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-timepicker-date-from-datepicker.command';
import { MInDayProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/min-day.provider';
import { QuantityOpenPlatformProvider } from '../../../../providers/open-platform/quantity.provider';
import { DateTimeEnablerProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/date-time-enabler.provider';
import { ResetSlotOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/reset-slot.command.service';
import {
  ResetVapsAndContractOPCommandService,
  ResetVapsValueOPCommandService,
} from '../../../../services/config-loader/commands/open-platform/reset-added-value.command.service';
import { CheckboxSpecialComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/checkbox-special/checkbox-special.component';
import { SpecialScenariosField } from '../../../../providers/special-scenarios-field.provider';
import { FieldLabelConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { FormInfoMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-message/form-info-message.component';
import { QuantityWarningOpenPlatformProvider } from '../../../../providers/open-platform/quantity-warning.provider';
import { TemperatureOptionLoaderService } from '../../../../services/config-loader/loaders/temperature.loader.service';
import { LoadSingleCatalogsTemperature } from '../../../../services/config-loader/commands/single-catalogs-temperature.command.service';
import {
  LoadTemperatureVapsService,
  ResetTemperatureFeatureService,
  ResetTemperatureVapsService,
  TemperatureValidatorRequiredService,
  ValidateCutoffTemperature,
} from '../../../../services/config-loader/commands/temperature-loaders.service';
import { SummerSetLoaderService } from '../../../../services/config-loader/loaders/summerset.loader.service';
import { TemperatureFeatureEnabler } from '../../../../providers/open-platform/temperature.enabler.provider';
import { ValidateTemperatureValueSpecializedCommandService } from '../../../../services/config-loader/commands/open-platform/validate-temperature-vap-specialized.command.service';
import { FormInputCheckboxV2Component } from '../../../../../../../shared/modules/configurable-form/components/form-input-checkbox-v2/form-input-checkbox-v2.component';
import { SpacingDisabledProvider } from '../../../../providers/spacing-disabled.provider';
import { contractVisibleFieldMxProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/contract-visible-field-mx.provider';
import { ResetUnloadTypeService } from '../../../../services/config-loader/commands/reset-unload-type.service';
import { FormInputRadioComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-inpu-radio/form-input-radio.component';
import { YesNoOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/yes-no-option-loader.service';
import { FieldInputRadioConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-inpu-radio/models/field-input-radio-config.interface';
import { PumpLengthOptionLoaderUL } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/pump-length-option-loader.service';
import { HandleLinearMeterChangeCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-linear-meter-change.command';
import { LoadPaymentTermsService } from '@ordersnproducts/modules/shared/modules/payment-terms/services/payment-terms.command.service';
import { PaymentTermsLoaderRMXULService } from '@ordersnproducts/modules/shared/modules/payment-terms/services/payment-terms.loader.service';
import { PumpRmsULProvider } from '@ordersnproducts/modules/shared/modules/pump-rms-ul/services/pump-rms-ul.provider';
import { UniversalLinkUnloadTypesLoaderService } from '../../../../services/config-loader/loaders/unload-type-ul.loader.service';
import { LoadSingleCatalogsPumpCapacity } from '../../../../services/config-loader/commands/single-catalogs-pump-capacity.command.service';
import { PumpApiOptionLoaderUniversalLink } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/pump-with-api-option-loader-UL.service';
import { LoadSingleCatalogsLoadSize } from '../../../../services/config-loader/commands/single-catalogs-load-size.command.service';
import { AddedValueOpenPlatformDisabler } from '../../../../providers/open-platform/added-value-enabler.provider';
import {
  LoadChildAddedValuesRMXUL,
  LoadProductAddedRMXULValues,
} from '../../../../services/config-loader/commands/open-platform/load-added-value-rmx-ul.command.service';
import { AdddedValuesLoaderRMXULService } from '../../../../services/config-loader/loaders/added-value-rmx-ul.service';
import { PumpAvailability } from '../../../../providers/pump-availabe.provider';
import { PumpableProjectProfilesRMXULOptionLoader } from '../../../../services/config-loader/loaders/pumpable-project-profile-rmx-ul.service.loader';
import { HandlePumpWithLinearMetersCommandUL } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-pump-linear-meters.command-ul';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';
import { HandlePumpLengthCommandUL } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-pump-capacity.command';
const MAX_LENGTH_ADDITIONAL_INFO = '63';
const MAX_LENGTH_COLOR_INFO = '20';
export const RMS_UL = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: 'id',
      placeholder: 'id',
      hidden: true,
      visible: false,
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ProductsOptionsLoaderOpenPlatformService,
      optionsProvider: ProductsOptionsLoaderOpenPlatformProvider,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [ProductsOpenPlatformEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [
        LoadSingleCatalogsUnloadType,
        LoadSingleCatalogsApplication,
        LoadSingleCatalogsSpacing,
        LoadSingleCatalogsUnloadTime,
        LoadSingleCatalogsPumpCapacity,
        LoadSingleCatalogsLoadSize,
        LoadContractOpenPlatformCommandService,
        LoadSingleCatalogsProjectProfile,
        ResetSlotOpenPlatformCommandService,
        ResetVapsAndContractOPCommandService,
        LoadPaymentTermsService,
        LoadProductAddedRMXULValues,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-3x retail-control '],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      value: QuantityOpenPlatformProvider.DefaultValue,
      min: 0.01,
      step: 1,
      max: 99999,
      suffix: UNITS.CUBIC_METERS,
      validation: [Validators.required],
      warningMessage: QuantityWarningOpenPlatformProvider.IsLargeOrderMessageQuantity,
      decimals: 1,
      onChange: [ResetSlotOpenPlatformCommandService],
    } as FieldInputNumberConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control input-number-align'],
      placeholder: 'views.specifications.Adjustment',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.PRODUCT_PUMP_INFORMATIVE,
      dataTId: SpecFieldTestIds.PRODUCT_PUMP_INFORMATIVE,
      containerClassNames: ['field-12x field-md-6x'],
      text: 'views.specifications.pumping_not_available',
      hidden: PumpAvailability.RMXULShouldHide,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInputDateComponent,
      label: 'views.specifications.request_date',
      name: SpecFieldNames.DATE,
      dataTId: SpecFieldTestIds.REQUEST_DATE,
      containerClassNames: ['field-12x field-md-6x field-lg-3x rms-mod'],
      placeholder: '',
      forbiddenWeekDays: [WeekDay.SUNDAY],
      onChange: [SetTimepickerDateFromDatepickerCommand],
      translationNames: defaultDateTranslationNames,
      validation: [Validators.required],
      min: MInDayProvider,
      blocked: MasterDateBlocker.MasterDateOnly,
      presetDate: MasterDateBlocker.UniqueDate,
      disabled: DateTimeEnablerProvider.DisableDateFormField,
      hidden: DateTimeEnablerProvider.DisableDateFormField,
      hideOutsideDays: true,
    } as FieldDateInputConfig,
    {
      type: FormInputTimeComponent,
      label: 'views.specifications.request_time',
      name: SpecFieldNames.TIME,
      dataTId: SpecFieldTestIds.REQUEST_TIME,
      containerClassNames: ['field-12x field-md-6x field-lg-3x push-lg-6x rms-mod'],
      placeholder: '',
      hourFormat: TimepickerHourFormat.format12,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableTimeFormField,
      hidden: DateTimeEnablerProvider.DisableTimeFormField,
    } as FieldInputTimeConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.SCHEDULE_MOMENT,
      name: SpecFieldNames.SCHEDULE_MOMENT,
      dataTId: SpecFieldTestIds.SCHEDULE_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.WAITING_LIST_MOMENT,
      name: SpecFieldNames.WAITING_LIST_MOMENT,
      dataTId: SpecFieldTestIds.WAITING_LIST_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractsOptionLoaderOpenPlatformService,
      optionsProvider: ContractOptionsLoaderOpenPlatformProvider,
      placeholder: 'views.specifications.select_contract',
      visible: contractVisibleFieldMxProvider.Visible,
      validation: [Validators.required],
      onChange: [
        ResetVapsValueOPCommandService,
        LoadTemperatureVapsService,
        LoadSingleCatalogsTemperature,
        ResetSlotOpenPlatformCommandService,
        ResetTemperatureFeatureService,
        ResetUnloadTypeService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    // Temperature
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.TEMPERATURE_LABEL,
      dataTId: SpecFieldTestIds.TEMPERATURE_LABEL,
      containerClassNames: ['field-12x field-md-12x'],
      iconColor: 'message-grey',
      text: 'views.specifications.temperature.temp_control_conditions',
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.temperature.temperature_under',
      name: SpecFieldNames.TEMPERATURE_UNDER,
      dataTId: SpecFieldTestIds.TEMPERATURE_UNDER,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: TemperatureOptionLoaderService,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.DisableIfContractNotSelected,
      placeholder: 'views.specifications.temperature.temperature_under_placeholder',
      onChange: [TemperatureValidatorRequiredService, ResetTemperatureVapsService, ValidateCutoffTemperature],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputCheckboxV2Component,
      name: SpecFieldNames.TEMPERATURE_UNDER_DISABLED,
      dataTId: SpecFieldTestIds.TEMPERATURE_UNDER_DISABLED,
      hidden: true,
      value: true,
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.temperature.summer_set',
      name: SpecFieldNames.SUMMER_SET,
      dataTId: SpecFieldTestIds.SUMMER_SET,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureNitroExperience,
      disabled: TemperatureFeatureEnabler.DisableIfContractNotSelected,
      containerClassNames: ['field-12x field-md-5x retail-control'],
      optionsLoader: SummerSetLoaderService,
      index: -1,
      placeholder: 'views.specifications.temperature.summer_set_placeholder',
      onChange: [
        LoadChildAddedValuesNotFormulatingOpenPlatformCommandService,
        ResetSlotOpenPlatformCommandService,
        ValidateTemperatureValueSpecializedCommandService,
      ],
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormInputCheckboxV2Component,
      name: SpecFieldNames.TEMPERATURE_NONE_CONDITION,
      dataTId: SpecFieldTestIds.TEMPERATURE_NONE_CONDITION,
      containerClassNames: ['field-12x field-md-12x retail-control mb-3'],
      label: 'views.specifications.temperature.declining_temp_control',
      hidden: TemperatureFeatureEnabler.TemperatureConditionValidation,
    } as FieldConfig,
    // ICE
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.ICE_LABEL,
      dataTId: SpecFieldTestIds.ICE_LABEL,
      containerClassNames: ['field-12x field-md-12x'],
      iconColor: 'message-grey',
      text: 'views.specifications.ice.info',
      hidden: TemperatureFeatureEnabler.ValidateTemperatureIceExperience,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.ice.quantity',
      name: SpecFieldNames.ICE_QUANTITY,
      dataTId: SpecFieldTestIds.ICE_QUANTITY,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: TemperatureOptionLoaderService,
      hidden: TemperatureFeatureEnabler.ValidateTemperatureIceExperience,
      disabled: TemperatureFeatureEnabler.DisabledByContractVapHaveRefrigerant,
      placeholder: 'views.specifications.ice.quantity_placeholder',
      onChange: [ResetTemperatureVapsService, ValidateCutoffTemperature, ResetSlotOpenPlatformCommandService],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(0),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FIRST,
      index: 0,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: AdddedValuesLoaderRMXULService,
      onChange: [LoadChildAddedValuesRMXUL, ResetSlotOpenPlatformCommandService],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(1),
      dataTId: SpecFieldTestIds.VALUE_ADDED_SECOND,
      index: 1,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValuesRMXUL, ResetSlotOpenPlatformCommandService],
      optionsLoader: AdddedValuesLoaderRMXULService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(2),
      dataTId: SpecFieldTestIds.VALUE_ADDED_THIRD,
      index: 2,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValuesRMXUL, ResetSlotOpenPlatformCommandService],
      optionsLoader: AdddedValuesLoaderRMXULService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(3),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FOURTH,
      index: 3,
      loading: AddedValueOpenPlatformDisabler.IsLoading,
      limit: true,
      optionsLoader: AdddedValuesLoaderRMXULService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
      onChange: [ResetSlotOpenPlatformCommandService],
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.paymentTerms',
      name: SpecFieldNames.PAYMENT_TERMS,
      dataTId: SpecFieldTestIds.PAYMENT_TERMS,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      disabled: true,
      validation: [Validators.required],
      optionsLoader: PaymentTermsLoaderRMXULService,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: PumpableProjectProfilesRMXULOptionLoader,
      onChange: [SetProjectPropertiesCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
      onChange: [],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: LocalSpacingsLoaderService,
      validation: [Validators.required],
      onChange: [ResetSlotOpenPlatformCommandService],
      disabled: SpacingDisabledProvider.Disabled,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unloadTime',
      name: SpecFieldNames.DISCHARGE_TIME,
      dataTId: SpecFieldTestIds.UNLOAD_TIME,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.unloadTime',
      optionsLoader: SingleUnloadTimesLoaderService,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.unload_type',
      optionsLoader: UniversalLinkUnloadTypesLoaderService,
      onChange: [HandlePumpWithLinearMetersCommandUL],
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_capacity',
      name: SpecFieldNames.PUMP,
      dataTId: SpecFieldTestIds.PUMP_CAPACITY,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_pumpCapacity',
      optionsLoader: PumpApiOptionLoaderUniversalLink,
      validation: [Validators.required],
      hidden: PumpRmsULProvider.ValidatorPump,
      disabled: PumpRmsULProvider.ValidatorPump,
      onChange: [HandlePumpLengthCommandUL],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_length',
      name: SpecFieldNames.PUMP_LENGTH,
      dataTId: SpecFieldTestIds.PUMP_LENGTH,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_pumpLength',
      hidden: PumpRmsULProvider.ValidatorPumpLength,
      disabled: PumpRmsULProvider.ValidatorPumpLengthDisable,
      optionsLoader: PumpLengthOptionLoaderUL,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.pipes',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.PIPE_QUANTITY,
      dataTId: SpecFieldTestIds.PIPE_QUANTITY,
      min: 0,
      value: 0,
      step: 1,
      hidden: PumpRmsULProvider.ValidateDisplayPumpFields,
    } as FieldInputNumberConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.hoses',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.HOSES,
      dataTId: SpecFieldTestIds.HOSES,
      min: 0,
      value: 0,
      step: 1,
      hidden: PumpRmsULProvider.ValidateDisplayPumpFields,
    } as FieldInputNumberConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.linear_meters',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.LINEAR_METERS,
      dataTId: SpecFieldTestIds.LINEAR_METERS,
      min: 0,
      value: 0,
      step: 1,
      hidden: PumpRmsULProvider.ValidatorPumpLinearMeters,
      onChange: [HandleLinearMeterChangeCommand],
    } as FieldInputNumberConfig,
    {
      type: FormInputRadioComponent,
      label: 'views.specifications.cleanUp',
      containerClassNames: ['field-12x field-md-4x retail-control'],
      name: SpecFieldNames.CLEAN_UP,
      dataTId: SpecFieldTestIds.CLEAN_UP,
      optionsLoader: YesNoOptionLoader,
      showInline: true,
      validation: [Validators.required],
    } as FieldInputRadioConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.SPECIAL_INSTRUCTION_INFORMATIVE,
      dataTId: SpecFieldTestIds.SPECIAL_INSTRUCTION_INFORMATIVE,
      containerClassNames: ['field-12x field-md-8x'],
      text: 'views.specifications.extra_options',
      hidden: SpecialScenariosField.Hidden,
    } as FieldLabelConfig,
    {
      type: CheckboxSpecialComponent,
      name: SpecFieldNames.COLOR_INFO,
      dataTId: SpecFieldTestIds.COLOR_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      label: 'views.specifications.color',
      maxlength: MAX_LENGTH_COLOR_INFO,
      visible: SpecialScenariosField.Visible,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: CheckboxSpecialComponent,
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      label: 'views.specifications.special_instr',
      placeholder: 'views.specifications.special_instr_placeholder',
      maxlength: MAX_LENGTH_ADDITIONAL_INFO,
      validation: [],
    } as FieldConfig,
  ],
  chidlrenStrategies: [RmsChildrenStrategies.MasterContract, RmsChildrenStrategies.MasterDate],
} as RmsFormConfig;
